// RequireAuth.js
'use client';
import { connect } from 'react-redux';
import getMeData from '../selector/getMeData.js';
import digestJwtToken from '../action/digestJwtToken.js';
import RequireAuth from '../component/RequireAuth.jsx';
import getOperationData from '../selector/getOperationData.js';

const mapStateToProps = state => {
  return {
    isAuthed: !!getMeData(state, 'id'),
    token: getMeData(state, 'token'),
    otpToken: getOperationData(state, ['login'], 'otp'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    digestJwtToken: ({ token }) => dispatch(digestJwtToken({ token })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RequireAuth);
